import { AuthScope } from '@api/enum'

const menu: AuthScope[] = [AuthScope.SitesTousLecture, AuthScope.SitesUtilisateurLecture]

export { menu }
